import { IUploadExcelRequest } from "../../../models/request/bus/uploadExcelRequest";
import { bus_diemdontra, BusDiemDonTraItemResponse } from "../../../models/response/bus/bus_diemdontra";
import { bus_loaidiemdon } from "../../../models/response/bus/bus_loaidiemdon";
import {
	eBusDiemDonTraActionTypeIds,
	IBusDiemDonTraChangeSelectedIds,
	IBusDiemDonTraCloseConfirm,
	IBusDiemDonTraCloseDetail,
	IBusDiemDonTraCloseImportModal,
	IBusDiemDonTraDeleteErr,
	IBusDiemDonTraDeleteStart,
	IBusDiemDonTraDeleteSuccess,
	IBusDiemDonTraImportErr,
	IBusDiemDonTraImportStart,
	IBusDiemDonTraImportSuccess,
	IBusDiemDonTraLoadErr,
	IBusDiemDonTraLoadStart,
	IBusDiemDonTraLoadSuccess,
	IBusDiemDonTraSaveErr,
	IBusDiemDonTraSaveStart,
	IBusDiemDonTraSaveSuccess,
	IBusDiemDonTraShowConfirm,
	IBusDiemDonTraShowDetail,
	IBusDiemDonTraShowImportModal,
	IBusDiemDonTraValidateImportErr,
	IBusDiemDonTraValidateImportStart,
	IBusDiemDonTraValidateImportSuccess,
	IBusLoaiDiemDonLoadErr,
	IBusLoaiDiemDonLoadStart,
	IBusLoaiDiemDonLoadSuccess
} from "../../action-types/bus/IBusDiemDonTraActionTypes";

export const busDiemDonTraActions = {
	loadBusDiemDonTraStart: (dm_coso_id: number): IBusDiemDonTraLoadStart => {
		return {
			type: eBusDiemDonTraActionTypeIds.LOAD_START,
			payload: dm_coso_id
		}
	},
	loadBusDiemDonTraSuccess: (data: BusDiemDonTraItemResponse[]): IBusDiemDonTraLoadSuccess => {
		return {
			type: eBusDiemDonTraActionTypeIds.LOAD_SUCCESS,
			payload: data
		}
	},
	loadBusDiemDonTraError: (message: string): IBusDiemDonTraLoadErr => {
		return {
			type: eBusDiemDonTraActionTypeIds.LOAD_ERROR,
			payload: message
		}
	},
	loadBusLoaiDiemDonStart: (): IBusLoaiDiemDonLoadStart => {
		return {
			type: eBusDiemDonTraActionTypeIds.LOAD_LOAIDIEMDON_START
		}
	},
	loadBusLoaiDiemDonSuccess: (data: bus_loaidiemdon[]): IBusLoaiDiemDonLoadSuccess => {
		return {
			type: eBusDiemDonTraActionTypeIds.LOAD_LOAIDIEMDON_SUCCESS,
			payload: data
		}
	},
	loadBusLoaiDiemDonError: (message: string): IBusLoaiDiemDonLoadErr => {
		return {
			type: eBusDiemDonTraActionTypeIds.LOAD_LOAIDIEMDON_ERROR,
			payload: message
		}
	},
	showBusDiemDonTraDetail: (data?: BusDiemDonTraItemResponse): IBusDiemDonTraShowDetail => {
		return {
			type: eBusDiemDonTraActionTypeIds.SHOW_DETAIL,
			payload: data
		}
	},
	closeBusDiemDonTraDetail: (): IBusDiemDonTraCloseDetail => {
		return {
			type: eBusDiemDonTraActionTypeIds.CLOSE_DETAIL
		}
	},
	changeBusDiemDonTraSelectedIds: (ids: number[]): IBusDiemDonTraChangeSelectedIds => {
		return {
			type: eBusDiemDonTraActionTypeIds.CHANGE_SELECTED_IDS,
			payload: ids
		}
	},
	showBusDiemDonTraConfirm: (): IBusDiemDonTraShowConfirm => {
		return {
			type: eBusDiemDonTraActionTypeIds.SHOW_CONFIRM
		}
	},
	closeBusDiemDonTraConfirm: (): IBusDiemDonTraCloseConfirm => {
		return {
			type: eBusDiemDonTraActionTypeIds.CLOSE_CONFIRM
		}
	},
	saveBusDiemDonTraStart: (data: bus_diemdontra): IBusDiemDonTraSaveStart => {
		return {
			type: eBusDiemDonTraActionTypeIds.SAVE_START,
			payload: data
		}
	},
	saveBusDiemDonTraSuccess: (is_update: boolean): IBusDiemDonTraSaveSuccess => {
		return {
			type: eBusDiemDonTraActionTypeIds.SAVE_SUCCESS,
			payload: is_update
		}
	},
	saveBusDiemDonTraError: (message: string): IBusDiemDonTraSaveErr => {
		return {
			type: eBusDiemDonTraActionTypeIds.SAVE_ERROR,
			payload: message
		}
	},
	deleteBusDiemDonTraStart: (id: number): IBusDiemDonTraDeleteStart => {
		return {
			type: eBusDiemDonTraActionTypeIds.DELETE_START,
			payload: id
		}
	},
	deleteBusDiemDonTraSuccess: (): IBusDiemDonTraDeleteSuccess => {
		return {
			type: eBusDiemDonTraActionTypeIds.DELETE_SUCCESS
		}
	},
	deleteBusDiemDonTraError: (message: string): IBusDiemDonTraDeleteErr => {
		return {
			type: eBusDiemDonTraActionTypeIds.DELETE_ERROR,
			payload: message
		}
	},
	showBusDiemDonTraImportModal: (): IBusDiemDonTraShowImportModal => {
		return {
			type: eBusDiemDonTraActionTypeIds.SHOW_IMPORT_MODAL
		}
	},
	closeBusDiemDonTraImportModal: (): IBusDiemDonTraCloseImportModal => {
		return {
			type: eBusDiemDonTraActionTypeIds.CLOSE_IMPORT_MODAL
		}
	},
	validateImportBusDiemDonTraStart: (request: IUploadExcelRequest): IBusDiemDonTraValidateImportStart => {
		return {
			type: eBusDiemDonTraActionTypeIds.VALIDATE_IMPORT_START,
			payload: request
		}
	},
	validateImportBusDiemDonTraSuccess: (data: any[]): IBusDiemDonTraValidateImportSuccess => {
		return {
			type: eBusDiemDonTraActionTypeIds.VALIDATE_IMPORT_SUCCESS,
			payload: data
		}
	},
	validateImportBusDiemDonTraError: (message: string): IBusDiemDonTraValidateImportErr => {
		return {
			type: eBusDiemDonTraActionTypeIds.VALIDATE_IMPORT_ERROR,
			payload: message
		}
	},
	importBusDiemDonTraStart: (request: IUploadExcelRequest): IBusDiemDonTraImportStart => {
		return {
			type: eBusDiemDonTraActionTypeIds.IMPORT_START,
			payload: request
		}
	},
	importBusDiemDonTraSuccess: (): IBusDiemDonTraImportSuccess => {
		return {
			type: eBusDiemDonTraActionTypeIds.IMPORT_SUCCESS
		}
	},
	importBusDiemDonTraError: (message: string): IBusDiemDonTraImportErr => {
		return {
			type: eBusDiemDonTraActionTypeIds.IMPORT_ERROR,
			payload: message
		}
	}
}
